import Avatar from "@material-ui/core/Avatar/Avatar";
import React from "react";

const tabConfig = [
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.logoURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Nombre",
    dataField: ["storeName"],
  },
  {
    columnTitle: "Phone Number",
    dataField: ["phoneNumber"],
  },
];

export default tabConfig;
